import { useSyncExternalStore } from 'react'
import { CollectionState } from '../collection-state'

export function useRecords (state: CollectionState) {
  return useSyncExternalStore(
    callback => state.addEventListener('recordsChanged', callback),
    () => state.records
  )
}
